import { Controller } from "@hotwired/stimulus";
import Mailcheck from "mailcheck";

// Connects to data-controller="email-suggestion"
export default class extends Controller {
  static targets = ["output"];
  static values = {
    feedback: String,
  };

  suggest(event) {
    Mailcheck.run({
      email: event.target.value,
      topLevelDomains: ["com", "org", "ch", "fr"],
      suggested: (suggestion) => {
        const feedback = this.#findOrInsertFeedbackDiv();
        feedback.textContent = this.feedbackValue.replace(
          /__TEMPLATE__/g,
          suggestion.full,
        );
      },
      empty: () => {
        const feedback = this.#findFeedbackDiv();
        feedback?.remove();
      },
    });
  }

  #findFeedbackDiv() {
    return this.element
      .closest(".form-group")
      .querySelector(".warning-feedback");
  }

  #findOrInsertFeedbackDiv() {
    const found = this.#findFeedbackDiv();

    if (found) return found;

    const feedback = document.createElement("div");
    feedback.classList.add("warning-feedback");

    this.element.closest(".form-group").appendChild(feedback);

    return feedback;
  }
}
